import { createRepeatActions } from '@sonar-software/xuder';
import { issuesSnoozedGetSlice } from './get';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';

const getActions = issuesSnoozedGetSlice.asyncActionCreators;

export const { resetGetIssuesSnoozed } = getActions;

export const { action: requestGetIssuesSnoozed, repeatAction: requestGetIssuesSnoozedAgain } = createRepeatActions(
	getActions.requestGetIssuesSnoozed,
	{
		count: 20,
		paginationDirection: PaginationDirection.Forward
	}
);
